import styled from 'styled-components';

export const DatePickersWrapper = styled.div`
	display: flex;
`;
